module.exports = () => {
    require('./accordion')()
}
